<p-skeleton
  [height]="height"
  [shape]="shape"
  [size]="size"
  [styleClass]="styleClass"
  [width]="width"
  class="m-skeleton"></p-skeleton>
